const SAML = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="8" fill="black" />
    <path
      d="M12.8233 7.25342C9.73917 7.25342 7.23889 9.75363 7.23889 12.8378C7.23889 15.9219 9.7391 18.4222 12.8233 18.4222L19.136 18.4222C19.5383 18.4222 19.8644 18.7483 19.8644 19.1505C19.8644 19.5528 19.5382 19.8789 19.136 19.8789H16.0404V20.8501H19.136C20.0747 20.8501 20.8356 20.0892 20.8356 19.1505C20.8356 18.2119 20.0747 17.451 19.136 17.451L12.8233 17.451C10.2755 17.451 8.21009 15.3856 8.21009 12.8378C8.21009 10.29 10.2755 8.22461 12.8233 8.22461H16.0484V7.25342L12.8233 7.25342Z"
      fill="url(#paint0_linear_804_8024)"
    />
    <path
      d="M12.8233 9.19581C10.8119 9.19581 9.18128 10.8264 9.18128 12.8378C9.18128 14.8492 10.8118 16.4798 12.8233 16.4798H19.136C20.6111 16.4798 21.8068 17.6755 21.8068 19.1505C21.8068 20.6256 20.611 21.8213 19.136 21.8213H16.0404V22.7925H19.136C21.1474 22.7925 22.778 21.162 22.778 19.1505C22.778 17.1391 21.1474 15.5086 19.136 15.5086H12.8233C11.3483 15.5086 10.1525 14.3128 10.1525 12.8378C10.1525 11.3628 11.3482 10.167 12.8233 10.167H16.0484V9.19581H12.8233Z"
      fill="url(#paint1_linear_804_8024)"
    />
    <path
      d="M11.1237 12.8378C11.1237 11.8991 11.8846 11.1382 12.8233 11.1382H16.0484V12.1094H12.8233C12.421 12.1094 12.0949 12.4355 12.0949 12.8378C12.0949 13.2401 12.421 13.5662 12.8233 13.5662H19.136C22.2201 13.5662 24.7204 16.0664 24.7204 19.1505C24.7204 22.2347 22.2202 24.7349 19.136 24.7349H16.0404V23.7637H19.136C21.6837 23.7637 23.7492 21.6983 23.7492 19.1505C23.7492 16.6028 21.6838 14.5374 19.136 14.5374L12.8233 14.5374C11.8846 14.5374 11.1237 13.7764 11.1237 12.8378Z"
      fill="url(#paint2_linear_804_8024)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_804_8024"
        x1="7.23889"
        y1="7.25342"
        x2="24.7204"
        y2="24.7349"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.328125" stopColor="#FF4F40" />
        <stop offset="0.697917" stopColor="#FF44DD" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_804_8024"
        x1="7.23889"
        y1="7.25342"
        x2="24.7204"
        y2="24.7349"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.328125" stopColor="#FF4F40" />
        <stop offset="0.697917" stopColor="#FF44DD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_804_8024"
        x1="7.23889"
        y1="7.25342"
        x2="24.7204"
        y2="24.7349"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.328125" stopColor="#FF4F40" />
        <stop offset="0.697917" stopColor="#FF44DD" />
      </linearGradient>
    </defs>
  </svg>
);

export default SAML;
